import { render, staticRenderFns } from "./OnlineschulungPage.vue?vue&type=template&id=19c8b70e&"
import script from "./OnlineschulungPage.vue?vue&type=script&lang=js&"
export * from "./OnlineschulungPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports